export default __webpack_public_path__ + "static/media/amenity-1.f14e5acf.jpg";